<template>
    <div>
        <page-header :title="$t('master.support')" />
        <div class="content-wrapper">
            <p class="contact-page-text">{{ $t('contact.text') }}</p>
            <text-box :label="$t('master.name')" inputType="text" @onChange="handleNameChange" :error="errors['name']" />
            <text-box :label="$t('master.email')" inputType="text" @onChange="handleEmailChange" :error="errors['email']" />
            <text-box :label="$t('contact.message')" inputType="text" @onChange="handleMessageChange" :error="errors['message']" rows="3" />
            <div class="button-wrapper w-100">
                <ion-button class="ion-margin-top" @click="handleContactSupport" shape="round" strong>
                    {{ $t('chat.send') }}
                </ion-button>
            </div>
        </div>
    </div>
</template>
<script>
import PageHeader from '@/components/PageHeader'
import TextBox from '@/components/TextBox'
import { validateContactSupport } from '@/utils/validators.js'
import AxiosController from '@/controllers/AxiosController'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'contact',
    components: { PageHeader, TextBox },
    data() {
        return {
            name: '',
            email: '',
            message: '',
            errors: [],
            error: '',
            isMobile
        }
    },
    methods: {
        handleNameChange: function(value) {
            this.name = value
        },
        handleEmailChange: function(value) {
            this.email = value
        },
        handleMessageChange: function(value) {
            this.message = value
        },
        handleContactSupport: function() {
            this.errors = []
            this.error = ''

            const { error } = validateContactSupport({
                name: this.name,
                email: this.email,
                message: this.message
            })
            if (error) {
                error.details.forEach(err => {
                    this.$set(this.errors, err.path[0], err.message)
                })
                return
            }
            const data = {
                name: this.name,
                email: this.email,
                message: this.message
            }
            AxiosController.post('contact-support', data).then(this.$router.push('/'))
        }
    }
}
</script>

<style lang="scss" scoped>
.content-wrapper {
    text-align: start;

    p {
        padding: 16px;
    }

    .button-wrapper {
        display: flex;
        justify-content: center;
    }
}

@media (min-width: 768px) {
    .contact-page-text {
        font-size: 20px;
    }
}
</style>
